import { render, staticRenderFns } from "./HomePageConfig.vue?vue&type=template&id=00daf83f&scoped=true&"
import script from "./HomePageConfig.vue?vue&type=script&lang=js&"
export * from "./HomePageConfig.vue?vue&type=script&lang=js&"
import style0 from "./HomePageConfig.vue?vue&type=style&index=0&id=00daf83f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00daf83f",
  null
  
)

export default component.exports